import React from 'react';
import { BinocularsIcon, FileIcon, NotePencilIcon, TruckIcon } from '@fronton/icons-react';
import {
  ButtonWithGAClickButton,
  LinkWithGAClickButton,
  MeasureBenefit,
  ReviewsBenefits,
  ReviewsCatalog,
  reviewsLink,
  ReviewsSection,
  Typography,
} from 'common/components';
import { REVIEWS_DATA } from 'common/components/kitchen';
import { fullWidthMobileButton } from 'common/styles/common';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';

type NewKitchenReviewsProps = {
  isRuRegion: boolean;
  signUpHref: string;
};

export const NewKitchenReviews: React.FC<NewKitchenReviewsProps> = ({ isRuRegion, signUpHref }) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits
        benefitsList={[
          {
            icon: NotePencilIcon,
            text: isRuRegion
              ? <MeasureBenefit elementBlock={KITCHEN_ELEMENT_BLOCK} href="/uslugi/checkout/?categoryId=1832&measure=true" />
              : 'Сделаем\nточный замер',
          },
          {
            icon: FileIcon,
            text: 'Подготовим\nдизайн-проект',
          },
          {
            icon: BinocularsIcon,
            text: 'Подберём\nнеобходимую технику',
          },
          {
            icon: TruckIcon,
            text: 'Доставим\nи\u00A0соберём кухню',
          },
        ]}
        newVariant
      />
    }
    description="Делаем кухни, которые хочется показывать"
    review={
      <ReviewsCatalog
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        newVariant
        reviewsList={REVIEWS_DATA}
        modalButton={
          <ButtonWithGAClickButton
            className={fullWidthMobileButton}
            elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
            elementName="Отзывы клиентов"
            elementText="Запишитесь"
            title="Запишитесь на проектирование"
            href={signUpHref}
            target="_blank"
            variant="accent"
            wide
          >
            Записаться на проектирование
          </ButtonWithGAClickButton>
        }
      />
    }
    title={<>
      <LinkWithGAClickButton
        className={reviewsLink}
        elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
        elementName="Отзывы клиентов"
        elementText="Запишитесь"
        title="Запишитесь на проектирование"
        href={signUpHref}
        target="_blank">
        <Typography variant="h2" color="text-invert">
          Запишитесь
        </Typography>
      </LinkWithGAClickButton>{' '}
      на&nbsp;бесплатное проектирование, <span>а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах!</span>
    </>
    }
  />
);
